<template>
  <div class="fontRight">
    <!-- 操作按钮 -->
    <div class="rightButtons">
      <rightOperations ref="rightOperations" :font-style-id="fontStyleId" :font-style-name="fontStyleName"
        :current-select-fonts="currentSelectFonts" @refreshTable="refreshTable" @updateCheck="updateCheck">
      </rightOperations>
    </div>
    <!-- 右侧表格 -->
    <div class="rightTable">
      <rightTable ref="rightTable" :font-style-id="fontStyleId" @setSelectFonts="setSelectFonts"></rightTable>
    </div>
  </div>
</template>

<script>
import rightOperations from "./rightOperations/rightOperations.vue";
import rightTable from "./rightTable/rightTable.vue";

export default {
  components: {
    rightOperations,
    rightTable
  },
  data() {
    return {
      fontStyleId: "", // 当前字体样式设置id
      fontStyleName: "", // 当前字体样式设置名称
      isReplaceReinforcedSymbol: 0, // 替换钢筋符号
      isClearFontStyle: 0, // 清除文字格式
      currentSelectFonts: [] // 当前表中选中的多个字体
    };
  },
  watch: {
    isReplaceReinforcedSymbol(val) {
      this.$refs.rightOperations.checked1 = val;
    },
    isClearFontStyle(val) {
      this.$refs.rightOperations.checked2 = val;
    }
  },
  methods: {
    // 刷新右侧表格
    refreshTable() {
      this.$refs.rightTable.getFontRightData();
    },
    // 复选框选择更新
    updateCheck(list) {
      this.isReplaceReinforcedSymbol = list[0];
      this.isClearFontStyle = list[1];
      this.$emit("refreshLeft");
    },
    // 设置右侧表格选中字体
    setSelectFonts(list) {
      this.currentSelectFonts = list;
    }
  }
};
</script>

<style lang='scss' scoped>
.fontRight {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .rightButtons {
    width: 100%;
    padding: var(--middle-space) var(--big-space);
    border-bottom: 1px solid #e5e8f1;
  }

  .rightTable {
    width: 100%;
    height: 1px;
    flex: 1 0 1px;
  }
}
</style>
